import { Reply } from "@mui/icons-material";
import { Box } from "@mui/material";

export default function CustomShareIcon({ className, style, onClick }) {
    const scale = 0.9;
    return <Box
        sx={{
            position: "relative",
            width: 20 * scale,
            height: 20 * scale,
            border: "2px solid",
            borderRadius: "4px",
        }}

        className={className}
        style={style}
        onClick={onClick}
    >
        <Box sx={{
            position: "absolute",
            top: -4 * scale,
            right: -4 * scale,
            width: 16 * scale,
            height: 16 * scale,
            backgroundColor: "white",
        }}></Box>

        <Reply
            className="scale-x-[-1]"
            sx={{
                position: "absolute",
                top: -9 * scale,
                right: -9 * scale,
                fontSize: 24 * scale,
                fontWeight: "bold",
            }}
        />
    </Box>;
};